import { updateClosestRegionInfo } from "@/features/cloudRenderingSlice";
import { useAppDispatch } from "@/hooks/redux";
import { useCloudRenderingRegionsQuery } from "@/hooks/useCloudRenderingRegionsQuery";
import { sortRegions } from "@/pages/latency-check/sortRegions";
import { useEffect } from "react";
import { useAuthentication } from "../auth";
import { setToken } from "../signalR";

export function CloudRenderingSessionProvider() {
  const { token } = useAuthentication();
  const dispatch = useAppDispatch();

  const { data: cloudRenderingRegions, isSuccess } =
    useCloudRenderingRegionsQuery({
      queryOptions: {
        // only regions that have a latency test url
        select: (data) => data.regions.filter((r) => r.latencyTestUrl),
      },
    });

  // Update closest region info when regions are fetched
  useEffect(() => {
    if (
      !isSuccess ||
      !cloudRenderingRegions ||
      cloudRenderingRegions.length === 0
    ) {
      return;
    }

    // Find the closest region (without any filters)
    const closestRegion = cloudRenderingRegions.sort(sortRegions)[0];

    if (closestRegion) {
      dispatch(updateClosestRegionInfo(closestRegion));
    }
  }, [cloudRenderingRegions, isSuccess, dispatch]);

  useEffect(() => {
    if (token) setToken(token);
  }, [token]);

  return null;
}
